/*
  Pop-up newsletter L&E.

  Parcours (revu le 16/09) : la pastille « Tes 10 % t'attendent » s'affiche en bas
  à gauche DÈS L'ARRIVÉE sur le site. Au bout du délai réglé (40 s), la pop-up
  s'ouvre d'elle-même et la pastille s'efface le temps qu'elle soit à l'écran. Si
  la personne ferme la pop-up, la pastille revient et reste : c'est elle qui permet
  de rouvrir, la pop-up ne se rouvre plus toute seule avant le délai de rappel.
  Une personne inscrite ne voit plus ni l'une ni l'autre.

  L'adresse part à DEUX endroits :
  - Shopify, par la soumission NATIVE du formulaire client (rechargement de page) :
    c'est ce qui inscrit la personne dans Clients > Abonnés au marketing.
  - Brevo, en arrière-plan (fetch no-cors + keepalive, la requête survit au
    rechargement), vers le formulaire « Pop-up site - 10% ».

  TROIS PIÈGES, vérifiés en direct le 14/09 :

  1) La soumission vers Shopify doit rester NATIVE. En AJAX, la protection anti-spam
     (Boutique en ligne > Préférences) répond « 400 Missing CAPTCHA token ».

  2) La pop-up ne doit PAS être un <dialog> ouvert en showModal(). Le top layer rend
     tout le reste du document inerte, l'iframe hCaptcha ne peut pas aboutir, et le
     clic ne produit alors aucune requête — en silence.

  3) La pop-up est exclue de /challenge (côté Liquid) : Shopify y demande de prouver
     qu'on n'est pas un robot, et la pop-up recouvrait le captcha.

  Le badge flottant hCaptcha est masqué par hideCaptchaBadge() ; en contrepartie la
  mention exigée par hCaptcha est affichée sous le formulaire (voir le Liquid). Le
  masquage ne vise QUE les petits badges fixes en bas d'écran, jamais la grande
  iframe du défi — sans quoi personne ne pourrait plus le résoudre.
*/
if (!customElements.get('le-newsletter-popup')) {
  class LeNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('.le-nlpop__overlay');
      if (!this.overlay || this.overlay.dataset.leReady === 'true') return;
      this.overlay.dataset.leReady = 'true';

      this.box = this.querySelector('.le-nlpop__box');
      this.teaser = this.querySelector('[data-teaser]');
      this.key = this.dataset.key || 'le-nlpop';
      this.pendingKey = this.key + '-pending';
      this.opened = false;

      if (this.dataset.hideBadge === 'true') this.hideCaptchaBadge();

      this.querySelectorAll('[data-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.dismiss());
      });

      this.overlay.addEventListener('click', (event) => {
        if (event.target === this.overlay) this.dismiss();
      });

      if (this.teaser) {
        this.teaser.addEventListener('click', () => {
          this.hideTeaser();
          this.open();
        });
      }

      this.onKeydown = (event) => {
        if (!this.opened) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.dismiss();
        } else if (event.key === 'Tab') {
          this.trapFocus(event);
        }
      };
      document.addEventListener('keydown', this.onKeydown);

      const copy = this.querySelector('[data-copy]');
      if (copy) copy.addEventListener('click', () => this.copyCode(copy));

      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', () => {
          // Pas de preventDefault : Shopify doit soumettre nativement (piège 1).
          const input = form.querySelector('input[type="email"]');
          if (input && !input.checkValidity()) return;
          this.setPending();
          if (input) this.sendToBrevo(input.value);
        });
      }

      const wasPending = this.readPending();
      const posted = !!this.querySelector('[data-posted]');
      const failed = !!this.querySelector('[data-form-error]');

      if (wasPending) this.clearPending();

      if (wasPending && posted) {
        this.writeState('subscribed');
        this.showSuccess();
        this.open();
        return;
      }

      if (wasPending && failed) {
        this.open();
        return;
      }

      // Dans l'éditeur de thème : toujours visible, pour pouvoir la régler.
      if (window.Shopify && window.Shopify.designMode) {
        this.open();
        return;
      }

      const state = this.readState();
      if (state && state.status === 'subscribed') return;

      if (this.dataset.mobile === 'false' && window.matchMedia('(max-width: 749px)').matches) return;

      if (!this.shouldShow()) {
        // Déjà vue et fermée : on ne la rouvre pas, on laisse la pastille.
        this.showTeaser();
        return;
      }

      // La pastille est là dès l'arrivée ; open() l'effacera le moment venu.
      this.showTeaser();
      this.arm();
    }

    disconnectedCallback() {
      this.disarm();
      if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
      if (this.badgeObserver) this.badgeObserver.disconnect();
    }

    hideCaptchaBadge() {
      const hide = () => {
        const frames = document.querySelectorAll(
          'iframe[src*="hcaptcha.com"], iframe[src*="recaptcha"], iframe[title*="hCaptcha" i]'
        );
        frames.forEach((frame) => {
          const host = frame.parentElement;
          if (!host || host.dataset.leBadgeHidden === 'true') return;
          const rect = host.getBoundingClientRect();
          const styles = window.getComputedStyle(host);
          const isSmall = rect.height > 0 && rect.height <= 130 && rect.width <= 420;
          const isLow = rect.bottom > window.innerHeight - 280;
          // On ne masque qu'un petit badge fixe en bas : jamais le défi lui-même.
          if (styles.position === 'fixed' && isSmall && isLow) {
            host.style.setProperty('display', 'none', 'important');
            host.dataset.leBadgeHidden = 'true';
          }
        });
      };

      hide();
      try {
        this.badgeObserver = new MutationObserver(hide);
        this.badgeObserver.observe(document.body, { childList: true, subtree: true });
      } catch (error) {
        /* pas d'observateur : le badge réapparaîtra, sans conséquence fonctionnelle */
      }
    }

    showTeaser() {
      if (!this.teaser) return;
      if (this.opened) return;
      const state = this.readState();
      if (state && state.status === 'subscribed') return;
      this.teaser.hidden = false;
    }

    hideTeaser() {
      if (this.teaser) this.teaser.hidden = true;
    }

    focusables() {
      if (!this.box) return [];
      return [...this.box.querySelectorAll('a[href], button:not([disabled]), input, select, textarea')].filter(
        (el) => el.offsetParent !== null
      );
    }

    trapFocus(event) {
      const items = this.focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    sendToBrevo(email) {
      const endpoint = this.dataset.brevo;
      if (!endpoint || !email) return;

      try {
        const payload = new FormData();
        payload.append('EMAIL', email);
        payload.append('email_address_check', '');
        payload.append('locale', 'fr');

        window.fetch(endpoint, {
          method: 'POST',
          body: payload,
          mode: 'no-cors',
          keepalive: true,
        });
      } catch (error) {
        /* Brevo injoignable : l'inscription Shopify se fait quand même */
      }
    }

    readPending() {
      try {
        return window.sessionStorage.getItem(this.pendingKey) === '1';
      } catch (error) {
        return false;
      }
    }

    setPending() {
      try {
        window.sessionStorage.setItem(this.pendingKey, '1');
      } catch (error) {
        /* stockage bloqué : on perdra juste l'écran de confirmation au retour */
      }
    }

    clearPending() {
      try {
        window.sessionStorage.removeItem(this.pendingKey);
      } catch (error) {
        /* rien à faire */
      }
    }

    readState() {
      try {
        return JSON.parse(window.localStorage.getItem(this.key) || 'null');
      } catch (error) {
        return null;
      }
    }

    writeState(status) {
      try {
        window.localStorage.setItem(this.key, JSON.stringify({ status: status, ts: Date.now() }));
      } catch (error) {
        /* navigation privée ou stockage bloqué : on laisse passer */
      }
    }

    shouldShow() {
      const state = this.readState();
      if (!state) return true;
      if (state.status === 'subscribed') return false;
      const days = parseInt(this.dataset.days, 10) || 30;
      return Date.now() - (state.ts || 0) > days * 86400000;
    }

    arm() {
      const delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
      const threshold = parseInt(this.dataset.scroll, 10) || 0;

      this.timer = window.setTimeout(() => this.open(), delay);

      if (threshold > 0) {
        this.onScroll = () => {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          if (scrollable <= 0) return;
          if ((window.scrollY / scrollable) * 100 >= threshold) this.open();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    disarm() {
      if (this.timer) window.clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      this.timer = null;
      this.onScroll = null;
    }

    open() {
      if (this.opened || !this.overlay) return;
      this.opened = true;
      this.disarm();
      this.hideTeaser();
      this.overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      const items = this.focusables();
      if (items.length > 1) {
        items[1].focus();
      } else if (items.length) {
        items[0].focus();
      }
    }

    dismiss() {
      const state = this.readState();
      if (!state || state.status !== 'subscribed') this.writeState('dismissed');
      this.close();
      this.showTeaser();
    }

    close() {
      this.opened = false;
      if (this.overlay) this.overlay.hidden = true;
      document.documentElement.style.overflow = '';
    }

    showSuccess() {
      const formPanel = this.querySelector('[data-view="form"]');
      const successPanel = this.querySelector('[data-view="success"]');
      if (formPanel) formPanel.hidden = true;
      if (successPanel) {
        successPanel.hidden = false;
        const title = successPanel.querySelector('[data-success-title]');
        if (title) title.focus();
      }
    }

    copyCode(button) {
      const code = this.querySelector('[data-code]');
      const label = button.querySelector('[data-copy-label]');
      if (!code) return;
      const value = code.textContent.trim();

      const done = () => {
        if (!label) return;
        const previous = label.textContent;
        label.textContent = 'Copié';
        window.setTimeout(() => {
          label.textContent = previous;
        }, 2000);
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(value).then(done).catch(() => this.selectCode(code));
      } else {
        this.selectCode(code);
        done();
      }
    }

    selectCode(code) {
      const range = document.createRange();
      range.selectNodeContents(code);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  customElements.define('le-newsletter-popup', LeNewsletterPopup);
}